import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { mapToContactFormApiModel } from '../functions/mappers.function';
import { AppStoreSelectors } from '../../root-store/app-store';
import { IContactForm } from '../models';

@Injectable({
	providedIn: 'root'
})
export class ContactFormService {

	private http = inject(HttpClient)
	private store = inject(Store)

	submitContactForm(model: IContactForm) {
		const params = mapToContactFormApiModel(model);
		return this.store.select(AppStoreSelectors.selectConfig).pipe(
			switchMap(config => this.http.post(`${config.apiUrl}/api/Accounts/SendContactEmail`, params))
		);
	}
}
